<template>
    <div class="menus">
        <a href="szerr.cn" class="logo">
            <active class="navItem">szerr</active>
        </a>
        <span class="nav">
            <a href="/">
                <active class="navItem">Home</active>
            </a>
            <a href="/blog">
                <active class="navItem">Blog</active>
            </a>
            <a href="/game">
                <active class="navItem">Game</active>
            </a>
            <a href="/music">
                <active class="navItem">Music</active>
            </a>
            <router-link to="/tools">
                <active class="navItem">Tools</active>
                <a href="/blog/search/">
                    <active class="navItem">Search</active>
                </a>
            </router-link>
            <a href="/about">
                <active class="navItem">About</active>
            </a>
        </span>
    </div>
</template>

<script>
import active from '@/components/active.vue'
export default {
    props: [
        'title',
    ],
    components: {
        active,
    },
    mounted: function () {
        let li = document.getElementsByClassName('navItem')
        for (let i of li) {
            if (i.textContent == this.title) {
                i.classList.add('choose')
                break
            }
        }
    }
}
</script>

<style>
.logo {
    color: seashell;
}

.choose {
    text-decoration: underline seashell;
}
.menus {
    padding-bottom: 20px;
    padding-top: 10px;
    justify-content: space-between;
    display: flex;
}
.nav {
    display: inline;
    overflow: auto;
}
.navItem {
    height: 40px;
    width: 120px;
    font-size: 25px;
    text-align: center;
    margin: auto;
}
</style>